import React from 'react';
import styled from 'styled-components';
import { typography } from '../../theme';

type TitlePropsType = {
  color?: string;
  children: React.ReactNode;
};

export const Title: React.FC<TitlePropsType> = ({ children, ...props }) => (
  <StyledTitle {...props} as="h3">
    {children}
  </StyledTitle>
);

export const StyledTitle = styled(typography.HeadingBrandMedium)<TitlePropsType>`
  text-align: left;
  margin-bottom: 5px;
  color: ${(p) => (p.color ? p.color : 'inherit')};
`;
